// Edit each paragraph and its mobile summary together. HTML links/emphasis are supported.
export const experience = {
  "id": "panel-1",
  "type": "story",
  "title": "Experience",
  "blocks": [
    {
      "heading": "Step Programme Overview",
      "desktop": "The Step Programme (<a href='https://www.iomdfenterprise.im/enterprise-support/all-schemes/step-programme/' target='_blank'>Listed here</a>) is an eight-week paid summer placement run by the Isle of Man Department for Enterprise for university students, typically in their second or penultimate year. Students work on project-based tasks with local host companies, gaining professional experience and earning a Living Wage. The programme concludes with a report and presentation to a judging panel, with awards for the best projects. I was placed at Salex LTD in Castletown, Isle of Man, and received the award for best presentation (see Image 2).",
      "mobile": "During the eight-week <a href='https://www.iomdfenterprise.im/enterprise-support/all-schemes/step-programme/' target='_blank' rel='noopener noreferrer'>2023 STEP Programme</a>, I interned at Salex LTD and won the <b>Best Presentation award</b>."
    },
    {
      "heading": "Salex LTD",
      "desktop": "Salex LTD (<a href='https://www.salexltd.com/' target='_blank'>listed here</a>)  handles West African commodity trading across regions from Tanzania to Zimbabwe. The organisation and its sister companies previously relied on a legacy process involving Excel spreadsheets and phone calls to track logistics, a system that was error-prone and inefficient. To modernise operations, a web application called FUATA was developed as a centralised platform for managing all shipments handled by Salex LTD.",
      "mobile": "<a href='https://www.salexltd.com/' target='_blank' rel='noopener noreferrer'>Salex LTD</a> uses FUATA to manage shipments across its West African commodity trading operations, replacing spreadsheets and phone calls."
    },
    {
      "heading": "",
      "desktop": "During my 2023 summer internship, my contributions included: Leading user training sessions to onboard staff onto the new system. Designing wireframes for key modules based on user and stakeholder needs, and engineering automated file workflows using Microsoft Power Automate.",
      "mobile": "I trained staff, designed module wireframes and automated file workflows with Microsoft Power Automate."
    },
    {
      "heading": "",
      "desktop": "This experience marked my first exposure to software maintenance, including attending developer meetings, engaging with ticket-based workflows, and aligning my deliverables with developer sprint cycles.",
      "mobile": "Working with developer meetings, tickets and sprints gave me practical experience in software maintenance."
    }
  ],
  "images": [
    {
      "src": "./info_images/stepProgramme.jpeg",
      "alt": "Experience Image 1",
      "caption": "Photo of all members of Step Programme 2023"
    },
    {
      "src": "./info_images/SalexLTD.jpeg",
      "alt": "Experience Image 2",
      "caption": "Award ceremony - receiving the best presentation award"
    }
  ],
  "videos": [
    {
      "type": "iframe",
      "url": "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2F3FMradio%2Fvideos%2F746133027320019%2F&show_text=false&width=476&t=0",
      "description": "2023 STEP programme interview with me"
    }
  ]
};
